export default __webpack_public_path__ + "static/media/instagram-outline.b132df91.svg";